<getm-swipe-actions
  #swipeActions
  [actions]="actions"
  (editClick)="onEditItem()"
  (deleteClick)="onDeleteItem()"
>
  <ion-grid class="cart-item__grid ion-no-padding">
    <ion-row class="ion-align-items-center ion-justify-content-between">
      <ion-col size="3">
        <ion-thumbnail class="cart-item__image">
          <ion-img [src]="product.imagen"></ion-img>
        </ion-thumbnail>
      </ion-col>

      <ion-col size="5">
        <ion-label class="cart-item__name" color="getm-neutral-dark">
          {{ product.title }}
        </ion-label>

        <ion-label class="cart-item__subtitle" color="getm-neutral-light">
          {{ product.subtitle }}
        </ion-label>

        <ion-label class="cart-item__sku" color="getm-neutral-light">
          {{ product.sku }}
        </ion-label>
      </ion-col>

      <ion-col size="4" class="ion-text-end">
        <ng-container
          *ngIf="
            isOrderActive &&
            (product.isNew || (product.isEdit && product.newAdd !== 0))
          "
        >
          <ion-chip
            [outline]="true"
            color="getm-neutral-pressed"
            class="product-status-badge"
          >
            <ion-label color="getm-neutral-pressed">
              <ng-container *ngIf="product.isNew">
                {{ 'Labels.new' | translate }}
              </ng-container>
              <ng-container *ngIf="product.isEdit && product.newAdd !== 0">
                {{ product.newAdd > 0 ? '+' + product.newAdd : product.newAdd }}
              </ng-container>
            </ion-label>
          </ion-chip>
        </ng-container>

        <getm-button
          class="kebab"
          color="link"
          size="default"
          icon="ellipsis-vertical"
          (btnClick)="openOptions()"
        ></getm-button>

        <ion-label class="cart-item__unit-price" color="getm-neutral-light">
          {{ product.precio | currency : undefined : 'symbol' : '1.2-2' }}
          {{ 'Labels.each-one' | translate }}
        </ion-label>

        <ion-label class="cart-item__total-price" color="getm-neutral-dark">
          {{
            product.precio * product.productos
              | currency : undefined : 'symbol' : '1.2-2'
          }}
        </ion-label>
      </ion-col>
    </ion-row>

    <ion-row class="cart-item__stepper ion-justify-content-end">
      <ion-col size="auto">
        <getm-quantity-selector
          [quantity]="product.productos || 1"
          [minimo]="1"
          [maximo]="'RangeSelector.Store.end' | translate"
          fill="outline"
          (quantityChange)="onQuantityChange($event)"
          (removeProduct)="onRemoveProduct()"
        ></getm-quantity-selector>
      </ion-col>
    </ion-row>
  </ion-grid>
</getm-swipe-actions>
